#import "./withdrawAccess.gql"

fragment userFragment on User {
  id
  bonusBalance
  bonusBalanceOn
  account {
    dogeWallet
  }
  name
  surname
  email
  phone
  emailApproved
  phoneApproved
  documentNum
  securityQuestionAnswer
  securityQuestionId
  username
  gender
  birthday
  vip
  currency {
    code
    name
  }
  thresholdStatus
  balance
  threshold {
    current
    amount
  }
  activeVager
  receiveSms
  minPay
  minPaySum
  middleName
  specialUser
  dobpay
  bkBalance
  language
  lastLogin
  profileIsFilled
  docsVerificationId
  needVerification
  profileIsApproved
  profileIsApprovedSum
  bkProfileIsApproved
  personalDataIsFilled
  localUser
  region
  sumRegion
  trusted
  externalLogin
  externalEgrisLogin
  madeFirstDeposit
  ...withdrawAccessFragment
}
